import { useMutation } from '@apollo/client/react'
import { LogOut } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GQL_LOGOUT } from '~/gql/auth/auth'
import { useAuth } from '~/helpers/store/auth'

function Logout() {
  const { t } = useTranslation()
  const [seconds, setSeconds] = useState(3)
  const { clearAuth } = useAuth()
  const [logoutGql] = useMutation(GQL_LOGOUT)

  useEffect(() => {
    logoutGql()
    const timeout = setTimeout(() => {
      clearAuth()
      window.location.href = '/'
    }, 3000)

    return () => {
      clearTimeout(timeout)
    }
  }, [clearAuth, logoutGql])

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [seconds])

  return (
    <div className="w-screen h-dvh bg-background flex flex-col justify-center items-center gap-4">
      <LogOut size={48} />
      <p className="font-bold font-primary text-foreground">
        {t('logout.redirect.message')}
        {' '}
        <span className="text-primary">
          {seconds}
          s
        </span>
      </p>
    </div>
  )
}

export default Logout
